import React, {useState} from "react";
import styled, {css} from "styled-components";
import IndicatorsCascadeList from "../../indicator/IndicatorCascade/IndicatorsCascadeList";
import OKR_target from "../../../images/OKR/OKR_target.svg";
import accountSVG from "../../../images/account.svg";
import updateIMG from "../../../images/update.svg";
import SubTagPlentyCard from "../../tag/subTag/SubTagPlentyCard";
import {getDateInFrench, getLateInfo} from "../../../utils/dateUtils";
import {getImage, getWeatherImage} from "../../../utils/utils";
import {useDispatch, useSelector} from "react-redux";
import {useLocation} from "react-router-dom";
import {DisplayForHead} from "../../../permissions/DisplayAccordingToRole";
import DeleteButton from "../../buttons/DeleteButton";
import {deleteObjective, loadAllObjectives, loadOneObjective} from "../ObjectiveActions";
import {OKR_ROUTE} from "../../../routes/routesName";
import {loadProject} from "../../project/one-project/projectAction";
import YesNoModal from "../../modal/YesNoModal";
import ObjectiveModal from "../../modal/ObjectiveModal";
import IndicatorModal from "../../modal/IndicatorModal";
import AddButtonFullText from "../../buttons/AddButtonFullText";

const ObjectiveCascadeCard = ({objective, fromProject}) => {

    const [openIndicator, setOpenIndicator] = useState(false)
    const [isOpenCreateModal, setIsOpenCreateModal] = useState(false)
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false)
    const [openEditModal, setOpenEditModal] = useState(false)
    const currentUser = useSelector(state => state.currentUser)
    const project = useSelector(state => state.project)
    const location = useLocation()
    const dispatch = useDispatch()

    const hasException = () => {
        //If the pilot of the item is the current user and
        // if the item is indicator and the OKRPilot (===main) is the current user
        // if we are in guided update the pilot and the copilot and the sponsor of the project have exception
        return objective.pilot.id === currentUser.id || objective?.OKRPilot?.id === currentUser.id || (project.id !== 0 ? project.pilot.id === currentUser.id : false) || (project?.copilot?.id ? project.copilot.id === currentUser.id : false) || (project.axisSponsor ? project.axisSponsor.id === currentUser.id : false)
    }

    const handleOpenIndicator = () => {
        setOpenIndicator(!openIndicator)
    }
    const updateOKR = async () => {
        if (objective.id !== 0) {
            await dispatch(loadOneObjective(objective.id))
            setOpenEditModal(true)
        }
    }
    const deleteRequest = async (id) => {
        try {
            if (currentUser.status === 200) {
                    await dispatch(deleteObjective(id))

                if (location.pathname === OKR_ROUTE) {
                    dispatch(loadAllObjectives(currentUser.id))
                } else {
                    dispatch(loadProject(project.id))
                }
                setTimeout(() => setIsOpenDeleteModal(false), 500)
            }
        } catch {
            console.error("Une erreur est survenue.")
        }
    }
    const displayModal = () => {
        if(isOpenCreateModal){
            return (
                <IndicatorModal
                    indicatorId={0}
                    setOpen={setIsOpenCreateModal}
                    parentObjective={objective}
                    projectId={0}
                />
            )
        }
        if (isOpenDeleteModal) {
            return (
                <YesNoModal
                    name={"cet objectif ?"}
                    setOpenModal={setIsOpenDeleteModal}
                    handleClickYesAction={deleteRequest}
                    id={objective.id}
                />
            )
        }
        if (openEditModal) {
            return (
                <ObjectiveModal
                    setOpen={setOpenEditModal}
                    selectedObjectiveId={objective.id}
                    projectId={project.id}
                />
            )
        }

    }
    return(

        <>
          <Container>

              <Card onClick={handleOpenIndicator}>
                  <TopSection $mode={"okr"}>
                      <FlexRow>
                          <img src={OKR_target} alt={'icone pour OKR'}/>
                          <p className={"okr-name"}> {objective.title} </p>
                      </FlexRow>
                      <FlexRow>
                          <Date> Échéance : {objective.endDate ? getDateInFrench(objective.endDate) : "à déterminer"} </Date>
                          <Pilot>
                              <img className={'icon-pilot'}
                                   src={getImage(objective.pilot.photo, accountSVG)}
                                   alt={`${objective.pilot.firstName} ${objective.pilot.lastName}`}
                              />
                              <p> {objective.pilot.firstName === "Deleted" ? "Utilisateur supprimé" : objective.pilot.firstName} {objective.pilot.lastName === "User" ? "" : objective.pilot.lastName} </p>
                          </Pilot>
                      </FlexRow>
                      <LastSection $mode={"okr"}>

                          <ImageContainer>
                              <img src={getWeatherImage(objective.weather)} alt={"météo de l'okr"}/>
                          </ImageContainer>

                          <FlexRow className={'last-update'}>
                              <img src={updateIMG} alt={'icone mise à jour'}/>
                              <p className={"date"}>{getDateInFrench(objective.lastUpdate)}</p>
                          </FlexRow>
                      </LastSection>
                  </TopSection>

                  <TagSection>
                      <div className={"wrapper"}>
                          {objective.tags.map(tag => (
                              <SubTagPlentyCard
                                  key={tag.id + tag.name}
                                  color={tag.color}
                                  id={tag.id}
                                  category={tag.category}
                                  name={tag.name}
                                  className={"no-hover"}
                              />
                          ))}
                      </div>

                  </TagSection>
              </Card>
              {
                  !fromProject &&
                  <ButtonsContainer>
                      <DisplayForHead

                          hasException={hasException()}
                          component={
                              <UpdateOKRButton
                                  $mode={getLateInfo(objective)}
                                  onClick={updateOKR}
                              >
                                  Mettre à jour
                              </UpdateOKRButton>
                          }
                      />
                      <DisplayForHead
                          hasException={hasException()}
                          component={
                              <DeleteButton
                                  setOpenDeleteModal={setIsOpenDeleteModal}
                              />
                          }
                      />
                  </ButtonsContainer>
              }
          </Container>
            {
                displayModal()
            }
            {
                openIndicator &&
               <>
                   { !fromProject &&
                       <DisplayForHead
                       hasException={objective.pilot.id === currentUser.id
                           || (project.id !== 0 ? project.pilot.id === currentUser.id : false)
                           || (project?.copilot?.id ? project.copilot.id === currentUser.id : false)
                           || (project.axisSponsor ? project.axisSponsor.id === currentUser.id : false)}
                       component={
                           <AddButtonFullText
                               id={0}
                               setId={objective.id}
                               setUpdate={() => setIsOpenCreateModal(true)}
                               title={"Ajouter un résultat clé"}/>
                       }
                   />}
                   <IndicatorsCascadeList
                       indicators={objective.keyResults}
                       fromProject={fromProject}
                       objective={objective}
                   />
               </>
            }
        </>

    )
}


const Pilot = styled.div`
  display: flex;
  justify-content: flex-start;
`
const Container = styled.div`
  display: flex;
  flex-direction: column-reverse;
  width: 100%;


  @media (min-width: 768px) {
    flex-direction: row;
  }
`
const ImageContainer = styled.div`
  display: flex;
  justify-content: center;

  img {
    width: 3rem;
  }
`

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 90%;
  background-color: var(--color-white);
  box-shadow: rgba(0, 0, 0, 0.12) 0 6px 16px;
  border-radius: 15px;
  cursor: pointer;

  &:hover {
    background: var(--color-grey-03)
  }

  p {
    text-align: center;
    font-size: 13px;
  }
  
  @media (min-width: 768px) {
    height: 100%;
  }
  @media (min-width: 1000px) {
    min-width: 90%;
    height: unset;
    min-height: 6rem;
    gap: 1rem;
    padding: 0.5rem 1rem ;
    
    p {
      text-align: start
    }
    }
`
const TopSection = styled.div`
  grid-template-columns: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
  padding: 1em;
  grid-row-gap: 0.5em;
  width: 100%;
  @media (min-width: 768px) {
    display: grid;
    grid-template-columns:35% 35% 25%;
    cursor: pointer;
    grid-template-rows: unset;
    gap: 1em;
  }
  @media (min-width: 1000px) {
    grid-template-columns:35% 35% 25%;
    cursor: pointer;
    grid-template-rows: unset;
    gap: 1em;
  }
`

const LastSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  opacity: 1;
  @media (min-width: 768px) {

    display: flex;
    flex-direction: row;
  }

`
const TagSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  padding: 0 1rem;
  width: 100%;

  .wrapper {
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    margin: 0 0.5em;
    width: 100%;
    gap: 0.5rem;
    padding: 0.3rem;
  }
`

const FlexRow = styled.div`
  display: flex;
  grid-template-columns: 20% 35% 35%;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.5em;

  div {
    flex-grow: 0.5;
  }

  .okr-name {
    flex-grow: 1;
    font-weight: 700;
  }


  .icon-pilot {
    width: 2em;
    height: 2em;
    object-fit: cover;
    border-radius: 50%;
  }

  div {
    display: flex;
    align-items: center;
    gap: 0.5em;
  }

  @media (min-width: 768px) {
    flex-direction: row;
  }


`
const Date = styled.p`
  white-space: nowrap;
  font-size: 12px;

`
const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  justify-content: flex-end;
  @media (min-width: 1000px) {
    flex-direction: column;
    justify-content: center;
  }
`;

const UpdateOKRButton = styled.button`

  padding: 0.5rem;
  border: none;
  color: white;
  border-radius: 10px;
  cursor: pointer;
  margin-left: 0.5rem;
  ${(props) => {
    switch (props.$mode) {
        case "upToDate":
            return css`
          background-color: var(--color-green);
        `
        case "midLate":
            return css`
          background-color: var(--color-yellow);
        `
        case "highLate":
            return css`
          background-color: var(--color-red);
        `
        default:
            return css`
          color: black;
        `;
    }
}}
`;

export default ObjectiveCascadeCard